import { PropsWithChildren } from 'react';

export interface IDottedBackgroundProps {
    color?: 'cultured';
    gradient?: boolean;
    gradientValue?: `${number}%`;
    className?: string;
}

const colors = {
    cultured: '#FAF9F5',
};

const COMPONENT_CLASSNAME = 'h-full w-full overflow-auto';

const DottedBackground = ({
    color = 'cultured',
    gradient = false,
    gradientValue = '10%',
    className = '',
    children,
    ...props
}: PropsWithChildren<IDottedBackgroundProps>) => {
    const component = gradient ? (
        <div
            id="component-container"
            className={COMPONENT_CLASSNAME}
            style={{
                backgroundImage: `linear-gradient(to top, transparent, ${colors[color]} ${gradientValue})`,
            }}
        >
            {children}
        </div>
    ) : (
        <div id="component-container" className={COMPONENT_CLASSNAME}>
            {children}
        </div>
    );

    return (
        <div className={`${className} dotted-background-${color}`} {...props}>
            {component}
        </div>
    );
};

export default DottedBackground;
